import styles from "./Kantine.module.css";
import Text from "../../components/Text/Text.jsx";
import Spacer from "../../components/Spacer/Spacer.jsx";
import kantineImage from "../../assets/images/Kantine/Kantine_Hero.jpg";
import { Phone } from "lucide-react";

const modelle = [
  {
    title: "Betriebskantine",
    subtitle: "Wir übernehmen den kompletten Betrieb",
    description:
      "Ideal für Unternehmen mit vorhandenen Räumlichkeiten, die eine professionelle, moderne und nachhaltige Lösung suchen.",
    leistungen: [
      "Vollständige Übernahme des Kantinenbetriebs",
      "Frische, saisonale und gesunde Küche",
      "Individuelle Menüplanung (auch vegetarisch/vegan)",
      "Professionelles Personal & Service",
      "Transparente Kostenmodelle",
    ],
    vorteile: [
      "Keine interne Organisation nötig",
      "Hohe Qualität & konstante Verfügbarkeit",
      "Entlastung für HR & Facility Management",
    ],
  },
  {
    title: "Foodtruck",
    subtitle: "Flexible Verpflegung direkt vor Ort",
    description:
      "Perfekt für Standorte ohne Kantine oder für Unternehmen, die Abwechslung bieten möchten.",
    leistungen: [
      "Moderner Foodtruck mit täglich wechselnden Gerichten",
      "Schnelle Ausgabe, ideal für kurze Pausen",
      "Frische Bowls, Suppen, Pasta, Salate, Snacks",
      "Optional: Themenwochen, Event-Catering",
    ],
    vorteile: [
      "Keine Infrastruktur notwendig",
      "Maximale Flexibilität",
      "Hoher Erlebnisfaktor für Mitarbeitende",
    ],
  },
  {
    title: "Tägliches Buffet",
    subtitle: "Frisch geliefert",
    description:
      "Für Unternehmen, die ohne eigene Küche auskommen möchten, aber dennoch täglich frische Auswahl bieten wollen.",
    leistungen: [
      "Warmes & kaltes Buffet, täglich frisch zubereitet",
      "Auswahl aus mehreren Gerichten",
      "Gesund, ausgewogen, saisonal",
      "Lieferung und Aufbau inklusive",
    ],
    vorteile: [
      "Keine Investitionen in Küche oder Personal",
      "Große Auswahl, minimaler Aufwand",
      "Ideal für kleine und mittlere Unternehmen",
    ],
  },
];

const gruende = [
  { icon: "✨", label: "Frische & Qualität", text: "Wir kochen täglich mit hochwertigen Zutaten." },
  { icon: "🥦", label: "Gesund & ausgewogen", text: "Ernährung, die Energie gibt – nicht müde macht." },
  { icon: "📐", label: "Flexibel & skalierbar", text: "Lösungen für 50 bis 2.000 Mitarbeitende." },
  { icon: "🌱", label: "Regional & nachhaltig", text: "Kurze Wege, saisonale Produkte, wenig Food Waste." },
  { icon: "🤝", label: "Individuell", text: "Jedes Unternehmen ist anders – wir passen uns an." },
];

function Kantine() {
  return (
    <div className={styles.kantineContainer}>

      {/* Hero Section */}
      <div
        className={styles.hero}
        style={{ backgroundImage: `url(${kantineImage})` }}
      >
        <div className={styles.heroOverlay}>
          <div className={styles.heroContent}>
            <p className={styles.heroPretitle}>Betriebskantine & Mitarbeiterverpflegung</p>
            <h1 className={styles.heroTitle}>Genuss im Arbeitsalltag</h1>
            <p className={styles.heroSubtitle}>
              Frische, gesunde und leckere Verpflegung steigert Motivation,
              Zufriedenheit und Produktivität.
            </p>
            <div className={styles.heroButtons}>
              <div
                role="button"
                onClick={() => (window.location.href = "#modelle")}
              >
                Unsere Modelle
              </div>
              <div
                role="button"
                onClick={() => (window.location.href = "/kontakt")}
              >
                Beratung anfragen
              </div>
            </div>
          </div>
        </div>
      </div>

      <Spacer space={"70px"} />

      {/* Intro Text */}
      <Text
        title="Foodosia für Ihr Unternehmen"
        body="Foodosia unterstützt Unternehmen jeder Größe – flexibel, modern und mit echter Leidenschaft für gutes Essen. Ob bestehende Kantine, Foodtruck oder tägliches Buffet: Wir bringen Genuss in den Arbeitsalltag."
      />

      <Spacer space={"80px"} />

      {/* Modelle */}
      <div id="modelle" className={styles.modelleSection}>
        <div className={styles.modelleHeader}>
          <h2 className={styles.modelleTitle}>Unsere Modelle für Ihr Unternehmen</h2>
        </div>
        <div className={styles.modelleGrid}>
          {modelle.map((modell) => (
            <div key={modell.id} className={styles.modellCard}>
              <div className={styles.modellIcon}>{modell.icon}</div>
              <h3 className={styles.modellTitle}>{modell.title}</h3>
              <p className={styles.modellSubtitle}>{modell.subtitle}</p>
              <p className={styles.modellDescription}>{modell.description}</p>

              <div className={styles.modellSection}>
                <p className={styles.modellSectionLabel}>Was wir bieten</p>
                <ul className={styles.modellList}>
                  {modell.leistungen.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className={styles.modellSection}>
                <p className={styles.modellSectionLabel}>Vorteile</p>
                <ul className={styles.modellListVorteile}>
                  {modell.vorteile.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Spacer space={"85px"} />

      {/* Warum Foodosia */}
      <div className={styles.warumSection}>
        <div className={styles.warumInner}>
          <Text
            title="Warum Foodosia?"
            body="Wir stehen für Qualität, Nachhaltigkeit und individuelle Betreuung – von der ersten Anfrage bis zum täglichen Betrieb."
          />
          <Spacer space={"50px"} />
          <div className={styles.warumGrid}>
            {gruende.map((g, i) => (
              <div key={i} className={styles.warumCard}>
                <span className={styles.warumIcon}>{g.icon}</span>
                <strong className={styles.warumLabel}>{g.label}</strong>
                <p className={styles.warumText}>{g.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Spacer space={"85px"} />

      {/* CTA */}
      <div className={styles.ctaSection}>
        <div className={styles.ctaInner}>
        <h2 className={styles.ctaTitle}>
          <Phone size={36} color="white" />
          Unverbindliche Beratung
        </h2>          
          <p className={styles.ctaText}>
            Wir entwickeln gemeinsam das passende Verpflegungskonzept für Ihr
            Unternehmen – flexibel, transparent und maßgeschneidert.
          </p>
          <a href="/kontakt" className={styles.ctaButton}>
            Jetzt Beratung anfragen
          </a>
        </div>
      </div>

      <Spacer space={"80px"} />
    </div>
  );
}

export default Kantine;
